import { render } from "./IconTrekTopAssist.vue?vue&type=template&id=4e75ada7"
import script from "./IconTrekTopAssist.vue?vue&type=script&lang=js"
export * from "./IconTrekTopAssist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__